/** @format */

import React, { PureComponent } from 'react';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import I18n from '../../../components/Translate/I18n';
import { Typography } from '@material-ui/core';
import { LocalFunctionProps } from './LocalProps';
import OperationOnService from '../../../modules/block/OperationOnService';
import { LocalRequestView } from './LocalRequestView';

const _ = require('underscore');

class OperationOnServiceView extends PureComponent<LocalFunctionProps> {
    private operationOnService: OperationOnService;

    constructor(props: LocalFunctionProps, context: any) {
        super(props, context);
        this.operationOnService = new OperationOnService(this.props);
    }

    render(): React.ReactNode {
        return (
            <GridContainer>
                <GridItem xs={4}>
                    <LocalRequestView counter={1} parameters={this.operationOnService.getRequestParams()} />
                </GridItem>
                <GridItem xs={8}>
                    <GridContainer>
                        <GridItem xs={12}>
                            <Typography variant="subtitle2">
                                <I18n trans="prov:vb.block_reaction" />
                            </Typography>
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        );
    }
}

export default compose<any, any>(
    connect((): object => {
        return {};
    }),
    withStyles(adescomStyle)
)(OperationOnServiceView);
